import { connectColors } from '@/theme/colors';
import { Flex, Text } from '@lego/klik-ui';

type HeaderInfoProps = { data: string };

const HeaderInfo = ({ data }: HeaderInfoProps) => {
  return (
    <Flex
      flexDirection={'column'}
      padding={'0 16px'}
      borderRight={`1px solid ${connectColors.transparent.slate[700]}`}
      borderLeft={`1px solid ${connectColors.transparent.slate[700]}`}
      maxWidth={'400px'}
      flexWrap={'nowrap'}
    >
      <Text
        color={connectColors.core.offBlack}
        overflow={'hidden'}
        whiteSpace={'nowrap'}
        textOverflow={'ellipsis'}
        className="body-sm-medium"
      >
        {data}
      </Text>
    </Flex>
  );
};
export default HeaderInfo;
